"use client";

import { formatValue, statusColor } from "./formatters";
import type { RichDetail } from "@/lib/caonabo/rich-content";

type Props = { detail: RichDetail };

export default function ChatDetailCard({ detail }: Props) {
  return (
    <div
      className="caonabo-fade-in rounded-xl border overflow-hidden"
      style={{
        background: "rgba(255,255,255,0.03)",
        borderColor: "rgba(139,58,46,0.25)",
      }}
    >
      <div
        className="px-3 py-2"
        style={{
          background: "rgba(139,58,46,0.10)",
          borderBottom: "1px solid rgba(139,58,46,0.25)",
        }}
      >
        <span className="text-[11px] font-bold" style={{ color: "#D77F70" }}>
          {detail.title}
        </span>
      </div>
      <div className="px-3 py-2 grid grid-cols-2 gap-x-2 gap-y-1 text-[10.5px]">
        {detail.fields.map((f) => {
          const v = f.value;
          if (f.format === "status" && typeof v === "string") {
            const s = statusColor(v);
            return (
              <div key={f.key} className="contents">
                <span className="text-text-muted">{f.label}</span>
                <span>
                  <span
                    className="text-[9px] font-bold px-1.5 py-0.5 rounded"
                    style={{
                      background: s.bg,
                      color: s.color,
                      border: `1px solid ${s.border}`,
                    }}
                  >
                    {v}
                  </span>
                </span>
              </div>
            );
          }
          return (
            <div key={f.key} className="contents">
              <span className="text-text-muted">{f.label}</span>
              <span className="text-text tabular-nums">{formatValue(v, f.format)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
